<template>
    <div  v-if="show" class="popup-container h-100 col-12">
        <div class="popup bg-white border rounded-md m-auto w-96 mt-20" >

            <div class="popup-header d-flex p-2">
                <span class="text-md m-2 flex-1"> {{query.tab}} </span>
                <i class="float-end m-2cursor-pointer" @click.stop="close">

                    <svg xmlns="http://www.w3.org/2000/svg" fill="black" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>


                </i>
            </div>

            <Login v-if="query.tab === $store.state.ACCOUNT_TABS_LOGIN" :open="open" :close="close"/>
            <Signup v-if="query.tab === $store.state.ACCOUNT_TABS_SIGNUP" :open="open" :close="close"/>
            
        </div>
    </div>
  </template>
  
  <script>
    import Login from '@/components/LogInPopUp/Login'
    import Signup from '@/components/LogInPopUp/Signup'

  export default {
    name: 'LoginModal',
    props:['forceUpdate','confirmedFun'],
    components: {
        Login, Signup
    },
    async mounted(){
    },
    data () {
        return {
            show:false,
            query:{
                tab:this.$store.state.ACCOUNT_TABS_LOGIN
            },
            loading:false,
        }
    },
    methods: {
        open:function(query){
            this.show=true;
            if(query){this.query = {...query}}
        },
        close:function(e){
            this.show=false;
            this.forceUpdate();
        },
        confirmed(){
            this.close();
            this.confirmedFun(this.query)
        }
    }
  }
  </script>
  
<style scoped>
    .popup-footer{
        border-top: 1px solid rgba(0,0,0,0.05);
    }
    .popup-header{
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }
    .popup-container{
        z-index: 2;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        position: fixed;
        color: #000;
    }
   .popup{
        min-height: 250px;
        display: flex;
        flex-direction: column;
   }
   .lg-modal{
        min-width: 90%;
    }

    video{
        max-height: 80vh;
        width: 90vw;
    }

    .video-container{
        height: 80vh;
    }

</style>
  


// WEBPACK FOOTER //
// src/components/LogInPopUp/index.vue